var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8793 0C11.3206 0 9.93724 0.713683 9 1.94035C8.06276 0.713683 6.6794 0 5.12069 0C3.7631 0.00190534 2.46159 0.628322 1.50163 1.74185C0.54167 2.85538 0.00164258 4.36509 0 5.93986C0 12.4503 8.2094 17.6522 8.55853 17.8709C8.69421 17.9556 8.8459 18 9 18C9.1541 18 9.30579 17.9556 9.44147 17.8709C9.7906 17.6522 18 12.4503 18 5.93986C17.9984 4.36509 17.4583 2.85538 16.4984 1.74185C15.5384 0.628322 14.2369 0.00190534 12.8793 0ZM12.4534 12.8121C11.3728 13.8757 10.2177 14.833 9 15.674C7.78232 14.833 6.6272 13.8757 5.54664 12.8121C3.86534 11.139 1.86207 8.58759 1.86207 5.93986C1.86207 4.93736 2.20539 3.97593 2.8165 3.26706C3.42761 2.55819 4.25645 2.15995 5.12069 2.15995C6.50172 2.15995 7.65776 3.00593 8.13802 4.3685C8.20792 4.56713 8.32724 4.73711 8.48076 4.85676C8.63428 4.97641 8.81504 5.04031 9 5.04031C9.18496 5.04031 9.36572 4.97641 9.51924 4.85676C9.67276 4.73711 9.79208 4.56713 9.86198 4.3685C10.3422 3.00593 11.4983 2.15995 12.8793 2.15995C13.7435 2.15995 14.5724 2.55819 15.1835 3.26706C15.7946 3.97593 16.1379 4.93736 16.1379 5.93986C16.1379 8.58759 14.1347 11.139 12.4534 12.8121Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2b43e3cd2d8666d251fcf1bbb6f20504.svg";
export { ForwardRef as ReactComponent };